export default "/stablepool.08188747127d33da2bcde3e700dde7a6.svg";